import { types } from "./types";

const initialState = {
    // appConfig: {},
    // appConfigError: "",
    // loading: false,
    // isEditObligationModal: false,
    // filterUsersEnabled: ''
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'TRIGGER_LOADING':
      return {
        ...state,
        loading: action.payload,
      };
    case 'EDIT_OBLIGATION_MODAL':
      return {
        ...state,
        isEditObligationModal: action.payload,
      };
    case types.UPDATE_APP_CONFIG.SUCCESS:
    case types.RESTORE_APP_CONFIG.SUCCESS:
    case types.GET_APP_CONFIG.SUCCESS:
      return {
        ...state,
        appConfig: action.payload,
        appConfigError: ""
      };
    case types.UPDATE_APP_CONFIG.ERROR:
    case types.RESTORE_APP_CONFIG.ERROR:
    case types.GET_APP_CONFIG.ERROR:
      return {
        ...state,
        appConfigError: action.payload
      };
    case types.CLEAR_CONFIG_ERROR.SUCCESS:
      return {
        ...state,
        appConfigError: ""
      };
    case 'SET_FILTERED_USERS':
      return {
        ...state,
        filteredUsers: action.payload?.users,
        filterUsersEnabled: action.payload?.flag
      };
    case 'SET_OBL_FILTER_FIELD':
      return {
        ...state,
        [action.payload?.key]: action.payload?.value,
      };
    case types.SET_VARIABLE.SUCCESS:
      return {
        ...state,
        [action.payload?.key]: action.payload?.value,
      }
    case types.SEND_EMAIL.SUCCESS:
      return state;
    default:
      return state;
  }
}

export default reducer;
